let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j315U")).then(() => parcelRequire('liO2D'));